import React, { createContext, useMemo, useState, useEffect } from 'react';

export const LoginContext = createContext();

export const LoginProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem('user');
      if (stored) setUser(JSON.parse(stored));
    } catch {
      setUser(null);
    } finally {
      setHydrated(true);
    }
  }, []);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
    if (userData.refreshToken) localStorage.setItem('refreshToken', userData.refreshToken);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
    localStorage.removeItem('refreshToken');
  };

  const value = useMemo(
    () => ({
      user,
      isAuthenticated: !!user,
      hydrated,
      login,
      logout,
    }),
    [user, hydrated]
  );

  return <LoginContext.Provider value={value}>{hydrated ? children : null}</LoginContext.Provider>;
};
